export default "__VITE_ASSET__JJL$3G2z__"